import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
		bookings: {},
		pagination: { total: 0 },
		bookingsArray: []
	}),

	getters: {
		bookings(state) {
			return state.bookingsArray;
		},
		bookingPagination(state) {
			return state.pagination;
		}
	},

	actions: {
		setBooking({commit}, booking) {
			commit('setBooking', booking);
		},
		async getGuestBookings({ commit }, { phoneCallingCode, phoneNumber, email, page, type }) {
			const bookingsData = await api.getGuestBookings(
				phoneCallingCode, 
				phoneNumber, 
				email, 
				page, 
				type
			);
			commit('setBookings', bookingsData);
			commit('setPagination', bookingsData);
		},
		async getBookings({ commit }, { page, type }) {
			const bookingsData = await api.getCustomerBookings(page, type);
			console.log('customer');
			commit('setBookings', bookingsData);
			commit('setPagination', bookingsData);
		},
	},

	mutations: {
		setBooking(state, b) {
			Vue.set(state.bookings, b.id, {...b});
			Vue.set(state, 'bookingsArray', Object.values(state.bookings));
		},
		setPagination(state, bookingsData) {
			let pagination = {
				totalPage: Math.ceil(bookingsData.data.total / bookingsData.data.per_page),
				current: bookingsData.data.current_page,
				total: bookingsData.data.total,
				perPage: bookingsData.data.per_page
			};
			Vue.set(state, 'pagination', pagination);
		},
		setBookings(state, bookingsData) {
			let bookings = bookingsData.data.data;
			bookings.forEach((b) => {
				Vue.set(state.bookings, b.id, b);
			});
			Vue.set(state, 'bookingsArray', bookings);
		}
	}
}